import Swiper from "swiper";
import gsap from 'gsap'

import { Pagination, Autoplay  } from 'swiper/modules';

export default function(){

	const sliders = document.querySelectorAll('[data-name=vertical-slider]')

	if ( sliders.length > 0 ) {
		sliders.forEach(slider => {
			// Create the slider
			let swiper = new Swiper(slider, {
				modules: [Pagination, Autoplay],

				direction: 'horizontal',
				slidesPerView: 1,
				spaceBetween: 30,

				loop: true,
				speed: 800,

				pagination: {
					el: slider.parentNode.parentNode.querySelector('.swiper-pagination-mobile'),
					type: "fraction",
				},

				breakpoints: {
					768: {
						direction: 'vertical',

						pagination: {
							el: slider.parentNode.parentNode.querySelector('.swiper-pagination'),
							type: "fraction",
						},
					},
				},

				on: {
					beforeInit: function () {
						// Calculate the highest .swiper-slide and set that as the height of the .swiper-container
						//(vertical sliders need a height set)
						var maxHeight = 0;
						slider.querySelectorAll('.swiper-slide').forEach(function (slide) {
							var slideHeight = slide.offsetHeight;
							maxHeight = Math.max(maxHeight, slideHeight);
						});
						maxHeight = maxHeight + 100

						slider.style.height = maxHeight + 'px';
					},
					init: function(){
						// Navigation first item active
						const activeNavigationItem = document.querySelector('[data-slideto="1"]')
						activeNavigationItem.classList.add('active')
					},
					slideChange: function(){
						const navigationItems        = document.querySelectorAll( '[data-slideTo]' )
						const activeNavigationNumber = this.realIndex + 1
						const activeNavigationItem   = document.querySelector('[data-slideto="'+ activeNavigationNumber +'"]')
						if ( navigationItems.length > 0 ){
							navigationItems.forEach(element => {
								element.classList.remove('active')
							});
						}

						activeNavigationItem?.classList.add('active')

						// Growing line
						const line = document.querySelector('.vertical-line-container .vertical-line')
						const firstNavigationItem   = document.querySelector('[data-slideto="1"]')
						const currentNavigationItem = activeNavigationItem
						const spaceBetween = currentNavigationItem.offsetTop - firstNavigationItem.offsetTop
						
						gsap.to( line, { height: spaceBetween, duration: 0.5, ease: 'power1.out' } )
					}
				},
			});

			// Setup the navigation
			const navigationItems = document.querySelectorAll( '[data-slideTo]' )

			if ( navigationItems.length > 0 ){
				navigationItems.forEach(item => {
					const goTo = item.dataset.slideto - 1
					
					item.addEventListener('click', function(){
						swiper.slideTo(goTo)
					})
				});
			}
		});
	}
}